import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import {
	createResource,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import type { SummaryPagePreferences } from './SummaryPagePreferences.types.tsx';

const getSummaryPagePreferencesUrl = (planId: string): string =>
	`/rest/jpo/1.0/plans/${planId}/userProperties/summaryPage`;

// Fetching `userProperties/summaryPage` during the route transition (rather than a component side
// effect) fires the GET once per navigation, avoiding the duplicate GETs from discarded/concurrent
// renders re-running the container lifecycle hook.
export const summaryPagePreferencesResource: RouteResource<SummaryPagePreferences | null> =
	createResource({
		type: 'ADVANCED_ROADMAPS_SUMMARY_PREFERENCES',
		getKey: ({ match }: RouterContext) => match.params.planId ?? 'none',
		getData: async ({ match }: RouterContext): Promise<SummaryPagePreferences | null> => {
			const { planId } = match.params;
			if (planId == null) {
				return null;
			}
			const response = await fetchJson(getSummaryPagePreferencesUrl(planId), { method: 'GET' });
			return response.value ?? null;
		},
		maxAge: Infinity,
		isBrowserOnly: true,
	});
